import { render, staticRenderFns } from "./remediation-ogm.vue?vue&type=template&id=a347a72e&scoped=true"
import script from "./remediation-ogm.vue?vue&type=script&lang=js"
export * from "./remediation-ogm.vue?vue&type=script&lang=js"
import style0 from "./remediation-ogm.vue?vue&type=style&index=0&id=a347a72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a347a72e",
  null
  
)

export default component.exports